//* Para utilizar a captura manual dos campos, veja os comentarios em
//* `FormLeads.js`
import { nameValidateProps } from "../services/ValidateService";

const form = $('.newsletter-form, .cta-newsletter-form');

export const FormNewsOptions = {
  ...nameValidateProps,
  form,
  isNewsletter: true,
  modalMessage: true
};